import React, { Component } from 'react';
import { Monitor, Clock, Globe, Network } from 'lucide-react';
import moment from 'moment';


export class ActivityTable extends Component {
    constructor(props) {
        super(props);

        this.renderRows = this.renderRows.bind(this);
        this.prepareRowData = this.prepareRowData.bind(this);
    }

    cleanValue(value) {
        const NO_VALUE = '--';

        if (!value || value === 'null') {
            return NO_VALUE;
        }

        return value;
    }

    prepareRowData(rawData) {
        let preparedData = {
            type: null,
            createdAt: null,
            eventResponse: null,

            ipAddress: null,
            deviceName: null,
            country: null,
            timezone: null,
        };

        if (rawData.EventContextData) {
            preparedData.ipAddress = this.cleanValue(rawData.EventContextData.IpAddress);
            preparedData.deviceName = this.cleanValue(rawData.EventContextData.DeviceName);
            preparedData.country = this.cleanValue(rawData.EventContextData.Country);
            preparedData.timezone = rawData.EventContextData.Timezone;
        }

        let userFacingTimezone = (preparedData.timezone ? '(' + preparedData.timezone + ')' : '');

        preparedData.type = rawData.EventType;
        preparedData.eventResponse = rawData.EventResponse;
        preparedData.createdAt = moment(rawData.CreationDate).utc().format('Do MMM YYYY HH:mm') + ' ' + userFacingTimezone;

        return preparedData;
    }

    renderRows(data) {
        return data.map((event, key) => {
            return <div key={key}>{ActivityRow(this.prepareRowData(event))}</div>;
        })
    }

    render() {
        return (
            <div id="activityTable" className="flex flex-col gap-4">
                {this.renderRows(this.props.data)}
            </div>

        )
    }
}

ActivityTable.defaultProps = {
    data: [],
}


export const ActivityRow = ({type = '', createdAt = '', ipAddress = '', deviceName = '', country = '', eventResponse = null}) => (
    <div className="eventRow flex flex-col p-4 border border-border rounded-md gap-4">

        <div className="eventType flex flex-row items-center gap-1">
            <span className="text-sm font-medium text-foreground">{type}</span> 
            {EventResponseBadge(eventResponse)}
        </div>

        <div className="flex flex-col">
            <div className="meta text-xs text-muted-foreground flex flex-row items-center gap-2" title="Device Name"><Monitor className="size-3" /> {deviceName}</div>
            <div className="meta text-xs text-muted-foreground flex flex-row items-center gap-2" title="Timestamp"><Clock className="size-3" /> {createdAt}</div>
            <div className="meta text-xs text-muted-foreground flex flex-row items-center gap-2" title="Country"><Globe className="size-3" /> {country}</div>
            <div className="meta text-xs text-muted-foreground flex flex-row items-center gap-2" title="IP Address"><Network className="size-3" /> {ipAddress}</div>
        </div>
    </div>
);

export const EventResponseBadge = (value) => {
    if (!value || value === '') {
        return null;
    }

    if (value === 'Fail') {
        return <span className="activityBadge activityFailed text-[10px] font-medium bg-red-50 text-red-700 py-0.5 px-1 rounded-sm">Failed</span>
    }

    return null;
}

export default ActivityTable;